import { combineReducers } from 'redux'
import  DemoSlice  from './DemoSlice';
import SportsSlice from './SportsSlice';
import CasinoSlice from './CasinoSlice';
import LiveCasinoSlice from './LiveCasinoSlice';
import LayoutTemplateSlice from './LayoutTemplateSlice';
import AccountsSlice from './AccountsSlice';
import AlertSlice  from './AlertSlice';
import SidebarSelectedDataSlice from './SidebarSelectedDataSlice';
import SidebarHandlerSlice from './SidebarHandlerSlice';
import FavouritesSlice from './FavouritesSlice';
import BetslipSlice from './BetslipSlice';
import SelectLeaguesSlice from './SelectLeaguesSlice';
import TeaserBetslipSlice from './TeaserBetslipSlice';
import ParlayBetslipSlice from './ParlayBetslipSlice';
import VSBetslipSlice  from './VSBetslipSlice';
import LiveScoreNotifySlice from './LiveScoreNotifySlice'
import UnifiedAccountSlice from './UnifiedAccountSlice';
import BettingHistorySlice from "./BettingHistorySlice";
import PasswordSecuritySlice from './PasswordSecuritySlice';
import LandingPageSlice from './LandingPageSlice';
import NotificationSlice from './NotificationSlice';
import TopLeagueSlice from "./TopLeagueSlice";
import PromotionSlice from "./PromotionSlice";
import SalesForceSlice from './SalesForceSlice';
import HRBetslipSlice from './HRBetslipSlice';
import RacebookSlice from './RacebookSlice';
import LeaderboardSlice from './LeaderboardSlice';
import DigitalSportsTechIntegrationSlice from './DigitalSportsTechIntegrationSlice';
import StatsSlice from './StatsSlice'

/**
 * For combine all reduces to store
 * Author: Oliver.Nguyen
 */
const RootReducer = combineReducers({
    demo: DemoSlice,
    LayoutTemplateSlice: LayoutTemplateSlice,
    AccountsSlice: AccountsSlice,
    SportsSlice: SportsSlice,
    CasinoSlice: CasinoSlice,
    LiveCasinoSlice: LiveCasinoSlice,
    AlertSlice: AlertSlice,
    SidebarSelectedDataSlice: SidebarSelectedDataSlice,
    SidebarHandlerSlice: SidebarHandlerSlice,
    FavouritesSlice: FavouritesSlice,
    BetslipSlice: BetslipSlice,
    HRBetslipSlice: HRBetslipSlice,
    SelectLeaguesSlice: SelectLeaguesSlice,
    TeaserBetslipSlice: TeaserBetslipSlice,
    ParlayBetslipSlice: ParlayBetslipSlice,
    VSBetslipSlice: VSBetslipSlice,
    LiveScoreNotifySlice: LiveScoreNotifySlice,
    UnifiedAccountSlice: UnifiedAccountSlice,
    BettingHistorySlice: BettingHistorySlice,
    PasswordSecuritySlice: PasswordSecuritySlice,
    LandingPageSlice: LandingPageSlice,
    NotificationSlice: NotificationSlice,
    PromotionSlice: PromotionSlice,
    TopLeagueSlice: TopLeagueSlice,
    SalesForceSlice: SalesForceSlice,
    RacebookSlice: RacebookSlice,
    LeaderboardSlice: LeaderboardSlice,
    DigitalSportsTechIntegrationSlice: DigitalSportsTechIntegrationSlice,
    StatsSlice: StatsSlice,
})

export default RootReducer


// WEBPACK FOOTER //
// ./src/app/slices/RootReducer.js